// extracted by mini-css-extract-plugin
export default {"NoCarList":"NoCarList_NoCarList__YU2zl","message_container":"NoCarList_message_container__SjxRG","message":"NoCarList_message__diIl5"};